import { IdentifyableObject } from "../../web/src/providers/data/data-store";

export type ImportProbability =
  | 's' | 'ss' | 'h' | 'sh' | 'g' | 'u'
  | 'high!'
  | 'gelegentlich'
  | 'normal'
  | 'unbekannt'
  | 'undefined'
  | '';

export enum Probability {
  /** Daten fehlen */
  Undefined = 0,

  /** unklar (laut Quellen) */
  Unclear = 1,

  /** sehr selten */
  VeryLow = 2,

  /** sehr selten oder selten */
  VeryLowOrLow = 3,

  /** selten */
  Low = 4,

  /** gelegentlich */
  Moderate = 5,

  /** häufig */
  High = 6,

  /** sehr häufig oder häufig */
  VeryHighOrHigh = 7,

  /** sehr häufig */
  VeryHigh = 8,
}

export interface NamedThing {
  id?: number | string;
  name: string;
}

export interface LinkedData {
  drugs: Array<LinkedDrug>,
  groups: Array<LinkedDrugGroup>,
  diagnoses: Array<LinkedDiagnosis>,
}

export interface DrugGroup extends NamedThing {
  aliasId?: number;
}

export interface LinkedDrugGroup extends DrugGroup {
  drugs: Array<LinkedDrug>;
}

export interface UsageWarnings {
  contactLenses?: boolean;
  cancerScreening?: boolean;
  lightProtection?: boolean;
  skinCare?: boolean;
  thrombosis?: boolean;
}

export interface Drug<TIsTrademark extends boolean> extends NamedThing {
  isTrademark: TIsTrademark;
  usageWarnings?: UsageWarnings;
  effectStats?: [number, number, number]; // number of high, moderate and low probability effects
}

export interface LinkedDrugBase<TIsTrademark extends boolean> extends Drug<TIsTrademark> {
  effects: Array<LinkedEffect>;
  groups: Array<LinkedDrugGroup>;
}

export interface DrugTrademark extends Drug<true> {
  registrationInfo?: string;
  forms: string[];
}

export interface LinkedDrugTradeMark extends LinkedDrugBase<true>, DrugTrademark {
  substance: LinkedDrugSubstance;
}

export interface DrugSubstance extends Drug<false> {
  lastChangeDate: string;
  requiresPrescription: boolean;
  atcCodes?: string[];
  halfLife?: string;
}

export interface LinkedDrugSubstance extends LinkedDrugBase<false>, DrugSubstance {
  trademarks: Array<LinkedDrugTradeMark>;
}

export type LinkedDrug = LinkedDrugSubstance | LinkedDrugTradeMark;

export interface Diagnosis extends NamedThing {
  usageWarnings?: UsageWarnings;
}
export interface LinkedDiagnosis extends Diagnosis {
  effects: Array<LinkedEffect>;
}

export interface Effect {
  probability: Probability;
}
export interface LinkedEffect extends Effect {
  drug: LinkedDrug;
  diagnosis: LinkedDiagnosis;
}
export interface LinkedIoEffect extends Effect {
  drug: IoDrug;
  diagnosis: IoDiagnosis;
}

export type IoDrugGroup = DrugGroup & IdentifyableObject;
export type IoDrugSubstance = DrugSubstance & IdentifyableObject;
export type IoDrugTrademark = DrugTrademark & IdentifyableObject;
export type IoDrug = IoDrugSubstance | IoDrugTrademark;
export type IoDiagnosis = Diagnosis & IdentifyableObject;
export type IoEffect = Effect & IdentifyableObject;



// WEBPACK FOOTER //
// ./src/types.ts